import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Spinner } from '../../components/Spinner';
import { formatRelative } from '../../lib/format';
import type { Campaign } from '@shared/types';

export function AdminCampaignsPage() {
  const [data, setData] = useState<{ items: Campaign[]; total: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ items: Campaign[]; total: number }>('/api/admin/campaigns?pageSize=200')
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Campaigns</h1>
        <p className="text-sm text-ink-500 dark:text-ink-400">
          Every campaign across all organizations.
        </p>
      </header>
      {error && (
        <div className="rounded-lg bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-200 px-4 py-3 text-sm">
          {error}
        </div>
      )}
      {!data && (
        <div className="flex items-center justify-center py-16">
          <Spinner size={28} />
        </div>
      )}
      {data && (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Org</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((c) => (
                <tr key={c.id}>
                  <td className="font-medium">{c.name}</td>
                  <td className="text-sm text-ink-500 dark:text-ink-400 max-w-md truncate">
                    {c.description ?? '—'}
                  </td>
                  <td className="text-xs text-ink-500 dark:text-ink-400">
                    {c.organizationId.slice(0, 8)}…
                  </td>
                  <td className="text-xs">{formatRelative(c.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
